import i18next from 'i18next';

/**
 * Registers the coaching-ui package i18n resource bundles.
 * Keys are camelCase. Apps set `keySeparator: false`.
 */
export default function initI18n(): void {
  i18next.addResourceBundle('en', 'coaching-ui', {
    continueTo: 'Continue to {{name}}',
    skipTo: 'Skip to {{name}}',
    backTo: 'Go back to {{name}}',
    skippedSteps: 'Steps you skipped',
    metrics: 'Metrics',
    habits: 'Habits',
    specialConvos: 'Or have a special conversation',
    chooseNext: '#### What would you like to do next?',
    notASpecialConvo: 'This conversation is not available.',
    noCoachConfiguredFor: 'No coach is configured for {{botGroup}}/{{botHandle}}.',
    botTestBotMissing: 'Name a bot in the address: /admin/bot-test/<botGroup>/<botHandle>.',
    convoRestoreFailed: 'Could not restore the convo',
  });
}
